import { render } from "./main.vue?vue&type=template&id=490ca70c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=490ca70c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-490ca70c"

export default script